var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
//@ts-ignore
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { UploadBlock } from './modules/uploadblock';
import { BeckonText } from './modules/beckontextblock';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { useDispatch } from 'react-redux';
import { useToasts } from '@brg/ui';
import { PrefixGenerator } from './modules/prefixgenerator';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
export var CountryNamePrefixTitle = memo(function (props) {
    var prefix = props.prefix, name = props.name, onTitleClick = props.onTitleClick, titleStyle = props.titleStyle, display = props.display;
    var nameNSpaces = (name === null || name === void 0 ? void 0 : name.length) ? name.split(' ').length - 1 : 0;
    /*
        rin, [10.06.2022 12:21]
        если название страны состоит из одного слова, то она выводится вместе с префиксом (если хватает строки, иначе переносится С ПОСЛЕДНИМ ИЗ ПРЕФИКСОВ НА СЛЕД СТРОКУ)

        rin, [10.06.2022 12:22]
        - если название страны состоит из нескольких слов, то она начинается после последнего слова префикса (если хватает строки, иначе переносится НЕ РАЗРЫВАЯ НАЗВАНИЕ)
     */
    var showTitle = display !== undefined ? display : true;
    return React.createElement(React.Fragment, null, showTitle
        ? React.createElement(React.Fragment, null,
            React.createElement("span", { onClick: onTitleClick, style: titleStyle }, nameNSpaces
                ? React.createElement(React.Fragment, null,
                    prefix || '',
                    " ",
                    React.createElement("span", { style: { whiteSpace: 'nowrap', color: 'inherit' } }, name || ''))
                : React.createElement(React.Fragment, null,
                    prefix || '',
                    "\u00A0",
                    name || '')))
        : undefined);
});
export var CountryEditBlocks = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle, post = props.post, specBlockProps = props.specBlockProps;
    var blockType = post.specBlock.type;
    var longreadId = (post || {}).longreadId;
    // const filteredTitle = blockEls.length ? blockEls.filter((item) => item.typeElement === 'Title') : undefined
    var dispatch = useDispatch();
    var _a = specBlockProps || {}, externalArea = _a.externalArea, externalCountry = _a.externalCountry, externalCommon = _a.externalCommon, externalCountryEditData = _a.externalCountryEditData, paramCountryId = _a.paramCountryId, paramId = _a.paramId, isArea = _a.isArea, profile = _a.profile, t = _a.t, i18n = _a.i18n, breakPoint = _a.breakPoint, history = _a.history, isModerOwner = _a.isModerOwner, countryName = _a.countryName, countryPrefix = _a.countryPrefix, changesByNotOwner = _a.changesByNotOwner;
    var _b = useToasts(), error = _b.error, info = _b.info;
    var _c = externalCountry || {}, country = _c.country, isFetchCountry = _c.isFetchCountry;
    var _d = externalArea || {}, isFetchArea = _d.isFetchArea, area = _d.area;
    var needCountry = isArea ? true : !!country;
    // console.log('CountryEditBlocks', props, blockType, area,  needCountry, !isFetchCountry, !isFetchArea)
    return React.createElement(React.Fragment, null,
        React.createElement(Container, { className: "spec-country-edit-blocks-container" },
            React.createElement(React.Fragment, null,
                (['passport'].includes(blockType || '') && externalArea && needCountry && !isFetchCountry && !isFetchArea)
                    ? React.createElement(React.Fragment, null,
                        React.createElement(MagicBox, { justify: "center" }, "CountryPassport"))
                    : undefined,
                (['prefixgenerator'].includes(blockType || '') && area && needCountry && !isFetchCountry && !isFetchArea)
                    ? React.createElement(React.Fragment, null,
                        React.createElement(PrefixGenerator, __assign({}, specBlockProps)))
                    : undefined,
                ['coatofarmsgenerator'].includes(blockType || '')
                    ? React.createElement(React.Fragment, null, "CoatOfArms")
                    : undefined)));
};
var templateObject_1;
//# sourceMappingURL=countryEditBlocks.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
//@ts-ignore
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { UploadBlock } from './modules/uploadblock';
import { BeckonText } from './modules/beckontextblock';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { useDispatch } from 'react-redux';
import { useToasts } from '@brg/ui';
import { PrefixGenerator } from './modules/prefixgenerator';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
export var CountryNamePrefixTitle = memo(function (props) {
    var prefix = props.prefix, name = props.name, onTitleClick = props.onTitleClick, titleStyle = props.titleStyle, display = props.display;
    var nameNSpaces = (name === null || name === void 0 ? void 0 : name.length) ? name.split(' ').length - 1 : 0;
    /*
        rin, [10.06.2022 12:21]
        если название страны состоит из одного слова, то она выводится вместе с префиксом (если хватает строки, иначе переносится С ПОСЛЕДНИМ ИЗ ПРЕФИКСОВ НА СЛЕД СТРОКУ)

        rin, [10.06.2022 12:22]
        - если название страны состоит из нескольких слов, то она начинается после последнего слова префикса (если хватает строки, иначе переносится НЕ РАЗРЫВАЯ НАЗВАНИЕ)
     */
    var showTitle = display !== undefined ? display : true;
    return React.createElement(React.Fragment, null, showTitle
        ? React.createElement(React.Fragment, null,
            React.createElement("span", { onClick: onTitleClick, style: titleStyle }, nameNSpaces
                ? React.createElement(React.Fragment, null,
                    prefix || '',
                    " ",
                    React.createElement("span", { style: { whiteSpace: 'nowrap', color: 'inherit' } }, name || ''))
                : React.createElement(React.Fragment, null,
                    prefix || '',
                    "\u00A0",
                    name || '')))
        : undefined);
});
export var CountryEditBlocks = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle, post = props.post, specBlockProps = props.specBlockProps;
    var blockType = post.specBlock.type;
    var longreadId = (post || {}).longreadId;
    // const filteredTitle = blockEls.length ? blockEls.filter((item) => item.typeElement === 'Title') : undefined
    var dispatch = useDispatch();
    var _a = specBlockProps || {}, externalArea = _a.externalArea, externalCountry = _a.externalCountry, externalCommon = _a.externalCommon, externalCountryEditData = _a.externalCountryEditData, paramCountryId = _a.paramCountryId, paramId = _a.paramId, isArea = _a.isArea, profile = _a.profile, t = _a.t, i18n = _a.i18n, breakPoint = _a.breakPoint, history = _a.history, isModerOwner = _a.isModerOwner, countryName = _a.countryName, countryPrefix = _a.countryPrefix, changesByNotOwner = _a.changesByNotOwner;
    var _b = useToasts(), error = _b.error, info = _b.info;
    var _c = externalCountry || {}, country = _c.country, isFetchCountry = _c.isFetchCountry;
    var _d = externalArea || {}, isFetchArea = _d.isFetchArea, area = _d.area;
    var needCountry = isArea ? true : !!country;
    // console.log('CountryEditBlocks', props, blockType, area,  needCountry, !isFetchCountry, !isFetchArea)
    return React.createElement(React.Fragment, null,
        React.createElement(Container, { className: "spec-country-edit-blocks-container" },
            React.createElement(React.Fragment, null,
                (['passport'].includes(blockType || '') && externalArea && needCountry && !isFetchCountry && !isFetchArea)
                    ? React.createElement(React.Fragment, null,
                        React.createElement(MagicBox, { justify: "center" }, "CountryPassport"))
                    : undefined,
                (['prefixgenerator'].includes(blockType || '') && area && needCountry && !isFetchCountry && !isFetchArea)
                    ? React.createElement(React.Fragment, null,
                        React.createElement(PrefixGenerator, __assign({}, specBlockProps)))
                    : undefined,
                ['coatofarmsgenerator'].includes(blockType || '')
                    ? React.createElement(React.Fragment, null, "CoatOfArms")
                    : undefined)));
};
var templateObject_1;
//# sourceMappingURL=countryEditBlocks.js.map